"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PADLEFT = void 0;
exports.PADLEFT = {
    alias: 'COMPLETAR_ESQ',
    description: 'completa o texto com o {caracter} a esquerda até ficar do {tamanho}',
    arg_names: ['original', 'tamanho', 'caracter'],
    args_description: ['o texto original', 'o tamanho final do texto', 'completar com este caracter'],
};
